module.exports = __webpack_public_path__ + "img/jiaoxue_rate_bg.697ef369.png";